import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';

export type TabsTriggerLinkPropsData = {
  value: string;
  url: string;
};

export type TabsTriggerLinkProps = TabsTriggerLinkPropsData & {
  className?: string;
  children?: React.ReactNode;
};

export type TabsListProps = React.ComponentProps<typeof TabsPrimitive.Root> & {
  className?: string;
  ariaLabel?: string;
};
